import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';

import { Subscription } from 'rxjs';

import { CommonService } from '../../utilities/services/common.service';
import { ConsoleHeaderComponent } from '../console-header/console-header.component';
import { ConsoleMenuComponent } from '../console-menu/console-menu.component';
import { ChatComponent } from '../chat/chat.component';
import { ToastNotificationComponent } from '../../utilities/components/toast-notification/toast-notification.component';

@Component({
    selector: 'app-main',
    imports: [RouterOutlet, NgClass, ConsoleHeaderComponent, ConsoleMenuComponent, ChatComponent, ToastNotificationComponent],
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {
  private readonly commonService = inject(CommonService);

  menuSubscription!: Subscription
  stretchMenu!: boolean;
  openChat!: boolean;
  openGlossary!: boolean;

  ngOnInit() {
    this.menuSubscription = this.commonService.onStretchMenu().subscribe((strechStatus: boolean) => {
      this.stretchMenu = strechStatus;
    });
  }

  ngOnDestroy() {
    this.menuSubscription.unsubscribe();
  }

  toggleChat($event: any) {
    this.openChat = $event;
  }

  toggleGlossary($event: any) {
    this.openGlossary = $event;
  }

}
